module.exports = __webpack_public_path__ + "img/magnifying-glass-chart.2c8e6ed0.svg";